import bFormInput from './form-input.vue';

export default bFormInput;


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/bootstrap-vue/es/components/form-input/form-input.js
// module id = 483
// module chunks = 0